import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {registerModalPropsResolver} from './registrationPropsResolver';
import {socialLoginAvailability} from '../social.resolver';
import {IndividualCustomerRegistrationForm} from '../form/registration/individual/registrationForm';


export class RegisterContainer extends Component {
    static get propTypes() {
        return {
            showLoader: PropTypes.bool,
            forwardReferer: PropTypes.bool,
        };
    }

    static get defaultProps() {
        return {
            showLoader: true,
            forwardReferer: true,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
        
    }

    componentDidMount() {
        socialLoginAvailability()
            .then((response) => this.setState({
                socialRegisterAvailable: response,
                loading: false
            }));
    }

    render() {
        return (
            <Fragment>
                {!this.state.loading && (
                    <div className="form-wrapper">
                      
                        <IndividualCustomerRegistrationForm forwardReferer={this.props.forwardReferer} socialRegisterAvailable={this.state.socialRegisterAvailable}/>
                       
                    </div>
                )}
                {this.state.loading && props.showLoader && (
                    <div className="sk-circle"/>
                )}
            </Fragment>
        )
    }
}

const props = registerModalPropsResolver();
export const Registration = () => <RegisterContainer {...props}/>;
